import {Select, ISelect} from ".";
import { textChooser } from "../../../util/textChooser";
import countryCode from "../../../../assets/json/countryCode.json";

interface PhoneCodeProps extends ISelect {}

export const PhoneCode = (props: PhoneCodeProps) => {

    const countryCodeValues = countryCode.map((country) => ({
        label: `${country.name} (${country.dial_code})`,
        value: country.dial_code,
    }));

    return(
        <Select
            currentValue={"+51"}
            values={countryCodeValues}
            subLabel={textChooser("txt34")}
            hasError={false}
            hasIcon={false}
            hook={props?.hook}
        />
    )
}